<script>
import AppHeader from "@/components/Essentials/AppHeader.vue";
import AppFooter from "@/components/Essentials/AppFooter.vue";
import MM from "@/components/Decores/MM.vue";
import Fastnav from "@/components/Home/FastNav/Fastnav.vue";

export default {
  name: "DecoresPage",
  components : {
    Fastnav,
    MM,
    AppFooter,
    AppHeader

  }
}
</script>

<template>
  <AppHeader></AppHeader>
  <MM></MM>
  <Fastnav></Fastnav>
  <AppFooter></AppFooter>
</template>
